import type { OrgDriver, VehicleListItem, VehicleType } from 'types/api.generated';

export type OrgDriverAssignedVehicle = OrgDriver['assignedVehicles'][number];

/** Fleet vehicle IDs currently assigned to this driver. */
export function getDriverAssignedVehicleIds(driver: OrgDriver): string[] {
  return driver.assignedVehicles.map((v) => v.id);
}

export function getDriverDisplayName(driver: OrgDriver): string {
  const { user } = driver;
  const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return name || user.email;
}

/** Assigned vehicles whose type is not covered by an active verified licence. */
export function getAssignedLicenceMismatches(
  driver: OrgDriver,
): OrgDriverAssignedVehicle[] {
  const licensed = new Set<VehicleType>(driver.licenceVehicleTypes);
  return driver.assignedVehicles.filter((v) => !licensed.has(v.vehicleType));
}

/** Selected fleet rows (from /vehicles/mine) that lack a matching verified licence type. */
export function getSelectedLicenceMismatches(
  driver: OrgDriver,
  selectedIds: string[],
  fleet: VehicleListItem[],
): VehicleListItem[] {
  const licensed = new Set<VehicleType>(driver.licenceVehicleTypes);
  return fleet.filter(
    (v) => selectedIds.includes(v.id) && !licensed.has(v.vehicleType),
  );
}
